import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'start',
      padding: '1rem',
    },
    title: {
      height: '30px',
      width: '100%',
    },
  },
  content: {
    main: {
      padding: '1rem',
    },
    bar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      height: '300px',
    },
    content: {
      height: '100%',
    },
  },
  paragraph: {
    main: {
      marginTop: '1rem',
    },
    text: {
      height: '20px',
    },
  },
};

const SkeletonCarRentalContainerMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, content, paragraph } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonCarRentalContainerMobile"
    >
      <Row gutters>
        <Col style={header.main}>
          <Box className="fr-skeleton-box" style={header.box}>
            <Box className="fr-skeleton-element" style={header.title} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={content.main}>
            <Row gutters>
              <Col xs="12" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.content} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="6" style={paragraph.main}>
          <Box className="fr-skeleton-box" style={paragraph.text} />
        </Col>
      </Row>
    </Box>
  );
};
SkeletonCarRentalContainerMobile.componentName = 'SkeletonCarRentalContainerMobile';

export default SkeletonCarRentalContainerMobile;
